import React from 'react';
import LazyLoadImage from '../LazyLoadImage/LazyLoadImage';
import ShareToMedia from '../Common/ShareToMedia';
import { socialMedia } from '../Common/SocialMedia';
import { gaLogEvent } from '../React-GA/GA4Tracking';
import { Link } from 'react-router-dom';

const Blog = ({ data }) => {
  let NumberX = Math.floor(Math.random() * 300 + 1);

  return (
    <>
      <Link
        to={data.link}
        rel="noreferrer"
        aria-label={`Blog about: ${data.desc} , link`}
        data-title="Blog Site"
        onClick={() => gaLogEvent('Single Blog Link: ', data.link, 'Name', data.name)}
      >
        <div className="img">
          <figure>
            <LazyLoadImage
              alt={data.name + ': ' + data.desc}
              height={250}
              src={`https://picsum.photos/id/${NumberX}/700/250`}
              width={700}
            />
          </figure>
        </div>
        <div className="body">
          <h2 aria-label={data.name}>{data.name}</h2>

          <p className="blog-description">
            <span>{data.desc}</span>
          </p>
        </div>
        <div className="footer">
          {socialMedia.map((media, index) => (
            <ShareToMedia key={index} link={data.link} title={data.name} description={data.desc} media={media} />
          ))}
        </div>
      </Link>
    </>
  );
};

export default Blog;
